import "./report-page.css";
import React, { useState } from "react";
import { NavLink, Routes, Route } from "react-router-dom";
import { Auth, useAuth } from "../auth/AuthContext";
import { DocumentTitle } from "../DocumentTitle";
import { ReportTable } from "./ReportTable";

export const ReportPage = () => {
   const auth: Auth = useAuth();
   if (!auth?.user?.permissions?.licence?.canView) {
      return <div>You do not have permission to be here."</div>;
   }

   const [showEmpty, setShowEmpty] = useState<boolean>(true);

   const RedirectRoute = (): JSX.Element => {
      setTimeout(() => window.location.replace("#/report/usage"), 0);
      return <></>;
   };

   const htmlId = (suffix?: string): string => {
      const prefix = "report-page";
      return suffix ? prefix + "_" + suffix : prefix;
   };
   return (
      <DocumentTitle title="Report">
         <article id={htmlId()}>
            <nav>
               <NavLink to="/report/usage" id={htmlId("usage")}>
                  Usage
               </NavLink>
               <NavLink to="/report/billing" id={htmlId("billing")}>
                  Billing
               </NavLink>
               <input
                  id={htmlId("show-empty")}
                  type="checkbox"
                  checked={showEmpty}
                  onChange={() => setShowEmpty((prevValue) => !prevValue)}
               />
               <label htmlFor={htmlId("show-empty")}>Show Empty</label>
            </nav>
            <Routes>
               <Route path="usage" element={<ReportTable showEmpty={showEmpty} />} />
               <Route path="billing" element={<ReportTable showEmpty={showEmpty} />} />
               <Route path="*" element={<RedirectRoute />} />
            </Routes>
         </article>
      </DocumentTitle>
   );
};
